// ----------------------------------------------------------------------------
// Component: Author Hero
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_author-hero.scss';